// Organisation role selects the shell; assignments select widgets and data scope.
// SMB and contexts from older servers retain their existing experience.
export type WorkspaceContext = {
  active_organization: { organization_type: string } | null;
  workspace?: { platform_role: "OWNER" | "ADMIN" | "MANAGER" | "MEMBER";
    role_label: string; assigned_task_types: string[] } | null;
};

export const executionTaskTypes = new Set([
  "RECCE", "VISUALS", "PRODUCTION", "PACKAGING", "INSTALLATION", "STORE_COMPLIANCE", "STORE_LOCATION"
]);

export function isExecutionTask(task: { type: string }) {
  return executionTaskTypes.has(task.type);
}

export function workspaceExperience(context: WorkspaceContext | null | undefined) {
  const workspace = context?.workspace;
  const orgType = context?.active_organization?.organization_type;
  if (!workspace || !orgType || !["PRINTER", "AGENCY", "BRAND_OWNER", "RECCE", "DESIGN"].includes(orgType)) return null;
  const role = workspace.platform_role;
  const leadership = role !== "MEMBER";
  const ownerOrAdmin = role === "OWNER" || role === "ADMIN";
  const locations = orgType === "BRAND_OWNER" && leadership;
  const fieldWork = workspace.assigned_task_types.some(type => type === "RECCE" || type === "INSTALLATION");
  return {
    role, roleLabel: workspace.role_label, leadership, ownerOrAdmin, locations, fieldWork,
    projects: leadership,
    inbox: leadership,
    tasksTab: !ownerOrAdmin && !locations,
    defaultRoute: role === "MEMBER" && !fieldWork ? "/tasks" : "/home"
  };
}
